export const Forward10 = () => (
  <svg
    className='h-5 w-5 scale-[1.4] sm:h-[18px] sm:w-[18px]'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.25'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <path d='M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8' />
    <path d='M21 3v5h-5' />
    <text
      x='12'
      y='15'
      fontSize='9'
      fontWeight='bold'
      stroke='none'
      fill='currentColor'
      textAnchor='middle'
    >
      10
    </text>
  </svg>
);
